import { render, staticRenderFns } from "./reset-pwd-module.vue?vue&type=template&id=7fde6868&scoped=true"
import script from "./reset-pwd-module.vue?vue&type=script&lang=js"
export * from "./reset-pwd-module.vue?vue&type=script&lang=js"
import style0 from "./reset-pwd-module.vue?vue&type=style&index=0&id=7fde6868&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fde6868",
  null
  
)

export default component.exports